<template>
    <div class="dv5-upgrade">
        <div class="info__out" v-if="view.URL_param == 'true'">
            <div class="info" ref="modal" :style="{ background: colorBackground, border: colorBorder }">
                <div class="body_info">
                    <img :src="`/internacional/public/office5/img/info-general/backoffice.svg`" alt="">
                    <span v-html="view.translation.alert_no_active_plan" :style="{ color: colorFont }"></span>
                </div>
            </div>
        </div>
        <div class="dv5-header">
            <div class="dv5-title">{{ this.view.translation.change_your_plan }}</div>
            <div class="dv5-filter">
            </div>
        </div>
        <div class="grid-test">
            <div v-if="plans.length > 0"
                v-for="(plan, index) in plans"
                :key="index"
            >
                <CloudPlanListItem
                    :view="view"
                    :plan="plan"
                />
            </div>
            <div class="dv5-alert" v-if="plans.length < 1">
                <div class="alert" v-html="view.translation.without_upgrade_plans"></div>
                <a class="submit-btn" :href="view.rota_office_home">
                    <span>{{ view.translation.continue }}</span>
                </a>
            </div>
        </div>
    </div>
</template>


<script>
import CloudPlanListItem from './PlanListItem.vue'
export default {
    components: {
        CloudPlanListItem
    },
    name: "dv5-upgrade",
    props: ["view"],
    data() {
        return {
            plans: [],
            colorBackground: '#dbe8f5',
            colorBorder: '3px solid #97c8f7',
            colorFont: 'rgb(44 152 255)',
        }
    },

    mounted() {
        this.planVisible()
    },
    created() {
    },
    methods: {
        planVisible() {
            let value = []
            for (let i = 0; i < this.view.plans.length; i++) {
                if (this.view.plans[i].visivel == '1') {
                    value.push(this.view.plans[i])
                }
            }
            this.plans = value
        },
        closeAlert() {
            $('.is_free_plan').hide()
        }
    },
    computed: {
    },
    watch: {
    }
};
</script>
<style>
#content {
    padding: 0 !important;
}
</style>
<style scoped lang="scss">
@import '../../../../scss/extras/_variables';
.dv5-upgrade {
    width: 100%;
    height: auto;
    overflow: auto;

    .dv5-header {
        width: 100%;
        padding: 2% 1% 0 1%;

        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;

        background: #e9edf2;

        .dv5-title {
            font-family: 'Roboto';
            font-size: 2.5rem;
            color: #434343; /* #2D3748; */
        }
        .dv5-filter {
            width: 70%;
            height: auto;
            max-height: 3rem;
            font-family: 'Roboto';
            font-size: 1rem;

            display: flex;
            justify-content: space-between;
            align-items: center;

            color: #4A5568;
            border-bottom: 1px solid #CBD5E0;
            padding-top: 0.5rem;
            padding-bottom: 1rem;
            margin-bottom: 1rem;

            .filter {
                display: inline-flex;
                align-items: center;
                .select {
                    height: 26px;
                    width: 98px;
                    border-radius: 100px;
                    background-color: #0080FC;
                }
            }
        }
    }
    .grid-test {
        display: flex;
        gap: 50px;
        flex-wrap: wrap;
        justify-content: center;
        background: #e9edf2;
        padding: 25px;
        height: auto;
        min-height: 77vh;
        > div {
            flex-basis: 300px;
            justify-content: center;
        }
        .dv5-alert {
            display: flex;
            flex-basis: 600px;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;

            box-shadow: 0px 3px 5px #00000026;
            border-radius: 10px;
            height: 300px;
            position: relative;
            word-wrap: break-word;
            background-color: #fff;
            background-clip: border-box;

            .alert {
                text-align: center;
                margin-bottom: 0px;
            }

            button {
                border: none;
            }

            .submit-btn {
                width: 50%;
                margin-top: -50px;
                height: 3rem;
                background-color: $dv5-color1;
                border-radius: 4px;

                display: flex;
                align-items: center;
                justify-content: center;

                cursor: pointer;

                span {
                    font-size: 1.5rem;
                    color: #fff;
                }
            }
        }
    }
    .is_free_plan {
        min-height: 350px;
    }
}
.info__out {
    position: relative;

    .info {
        // background: $secondary-color-7;
        display: flex;
        justify-content: space-between;
        align-items: center;
        column-gap: 5px;
        padding: 0.4rem 1rem .4rem .5rem;
        margin: .1%;
        transition: .5s all ease;
        width: 99.8%;
        border-radius: 3px;

        .body_info {
            display: flex;
            align-items: center;

            img {
                width: 3%; //30%;
                height: auto;
            }

            span {
                padding-left: 1rem;
                display: block;
                font-weight: 600;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/dashboard-v5/upgrade/index.vue